<nav [ngClass]="{opened: menuOpened, menu: true}">
  <ul>
    <ng-container *ngFor="let label of adminGroups; let id = index;">
      <li class="category" (click)="toggleOpen(id)" *ngIf="hasOptions(filteredMenuItems, id)">

        {{label}}

        <mat-icon>{{opens[id] ? 'folder_open' : 'folder'}}</mat-icon>
      </li>
      <ul class="category-list" *ngIf="opens[id] && hasOptions(filteredMenuItems, id)">
        <ng-container *ngFor="let item of filteredMenuItems">
          <li [routerLink]="[item.link]" [ngClass]="{active: isActive(item.link)}" *ngIf="item.group === id">
            {{item.name}} <mat-icon>{{item.icon}}</mat-icon>
            <div *ngIf="item.tag" class="tag">{{item.tag()}}</div>
          </li>
          <hr *ngIf="item.hr && item.group === id"/>
        </ng-container>
      </ul>
    </ng-container>
    <ng-container *ngFor="let item of filteredMenuItems">
      <li [routerLink]="[item.link]" [ngClass]="{active: isActive(item.link)}" *ngIf="!item.hasOwnProperty('group')">
        {{item.name}} <mat-icon>{{item.icon}}</mat-icon>
        <div *ngIf="item.tag" class="tag">{{item.tag()}}</div>
      </li>
      <hr *ngIf="item.hr && !item.hasOwnProperty('group')"/>
    </ng-container>
  </ul>
</nav>
